import PocketBase from "pocketbase";

export const pb = new PocketBase(
  import.meta.env.VITE_POCKETBASE_URL ?? "http://127.0.0.1:8090",
);

// Same GET path shares one default requestKey; overlapping calls (React Strict Mode,
// React Query refetch, fast navigation) otherwise abort each other — see PocketBase
// auto-cancellation: https://github.com/pocketbase/js-sdk#auto-cancellation
pb.autoCancellation(false);
